import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BdHomepageEventFilter } from '../shared/interfaces/employer-event-filter';
import { ApiHelper } from '../core/services/api-helper';

@Injectable({
  providedIn: 'root',
})
export class BdHomepageService extends ApiHelper {
  getEvents(staffId: number, filters: BdHomepageEventFilter, pageNumber: number, pageSize: number): Observable<any> {
    const pagination = {
      skip: pageNumber * pageSize,
      take: pageSize,
    };

    const params = new HttpParams()
      .set('filters', JSON.stringify(filters))
      .set('pagination', JSON.stringify(pagination))
      .set('staffId', staffId.toString());

    const url = `${environment.API_URL}v2/BdHomepage/Events`;
    return this.getWithAccessToken(url, params);
  }

  getEventFilterOptions(staffId: number) {
    return this.getWithAccessToken(`${environment.API_URL}v2/BdHomepage/Events/FilterOptions/${staffId}`);
  }
}
